import { path, createCachedSelector, defaultKeySelector, bound } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { queryParamsSelector } from '@cbridge-packages/routing';
import { RuleValidity } from '@cbridge-tools/rules-data-grid';
import { IRuleFilter } from '@cbridge-tools/rules-data-grid-filter';
import { rulesManagementStoreSelector } from '../rulesManagement.selector';
import { ValidityFilterParam } from '../_helpers/validityFilterSearchParam';

export const rulesValidityFilterSelector = createCachedSelector(
  [
    path(rulesManagementStoreSelector).filter.validity(),
    bound(queryParamsSelector, ValidityFilterParam.name),
  ],
  (validity, activeFilters) => {
    const result: IRuleFilter<RuleValidity> = {
      [RuleValidity.Error]: {
        ...validity[RuleValidity.Error],
        isActive: activeFilters.includes(RuleValidity.Error),
      },
      [RuleValidity.Unused]: {
        ...validity[RuleValidity.Unused],
        isActive: activeFilters.includes(RuleValidity.Unused),
      },
      [RuleValidity.Useless]: {
        ...validity[RuleValidity.Useless],
        isActive: activeFilters.includes(RuleValidity.Useless),
      },
    };
    return result;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
